module.exports = __webpack_public_path__ + "img/stethoscope.d40b4d1b.svg";